import { graphql } from '@/gql';
import type { GenerateCallAvoidanceAnalysisQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateCallAvoidanceAnalysis = async ({ callLogId }: GenerateCallAvoidanceAnalysisQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callLogId,
    },
    query: graphql(`
      query GenerateCallAvoidanceAnalysis($callLogId: String!) {
        generateCallAvoidanceAnalysis(callLogId: $callLogId) {
          avoidanceType
          analysis
          isAvoidance
        }
      }
    `),
  });

  return response.data.generateCallAvoidanceAnalysis;
};
